import { MicrofrontendManager, ViewModel } from '@descomplica/microfrontend-core';
import { action, computed, makeObservable, observable } from 'mobx';

import envs from '@/infrastructure/config/envs';

import { ApplicationModel } from './models/application.model';
import { ClassifiersModel } from './models/classifiers.model';
import { ExercisesModel } from './models/exercises.model';
import { StudyPlanModel } from './models/studyPlan.model';
import { UserModel } from './models/user.model';

@ViewModel({ singleton: true })
export class MicrofrontendViewModel {
  @observable isLoading = true;
  @observable hasError: boolean;

  constructor(
    private readonly userModel: UserModel,
    private readonly applicationModel: ApplicationModel,
    private readonly classifiersModel: ClassifiersModel,
    private readonly studyPlanModel: StudyPlanModel,
    private readonly exercisesModel: ExercisesModel,
  ) {
    makeObservable(this);
  }

  @action
  async onInit() {
    try {
      await this.initializeMicrofrontend();

      await Promise.all([
        this.userModel.getIdentifiedAccount(),
        this.applicationModel.getApplication(),
        this.classifiersModel.getClassifiers(),
      ]).then(() =>
        Promise.all([
          this.studyPlanModel.getStudyPlan(),
          this.exercisesModel.getExercisesByClassifier(),
        ]),
      );
    } catch (error) {
      console.error(error);
      this.hasError = true;
    } finally {
      this.isLoading = false;
    }
  }

  @action
  async initializeMicrofrontend() {
    await MicrofrontendManager.init({
      pegasusUri: envs.pegasusUrl,
      caching: {
        namespace: envs.cachingNamespace,
      },
      settings: {
        launchDarklyClientId: envs.launchDarklyClientId,
      },
      recognition: {
        isEnabled: true,
        forceRedirectToSignIn: true,
        forceReautenticate: true,
        signInUrl: envs.recognitionSigninUrl,
        reauthenticateUrl: envs.recognitionReauthenticateUrl,
      },
    });
  }

  @computed
  get hasPermissionError() {
    return this.userModel.hasPermissionError;
  }
}
